import React, { useEffect } from "react";
import { Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Avatar, Dropdown, Space } from "antd";
import type { MenuProps } from "antd";
import { DownOutlined } from "@ant-design/icons";
import ReactGA from "react-ga4";
import { ErrorBoundary } from "react-error-boundary";

import placeHolder from "../../../../assets/images/profilePlaceholder.png";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import { getProfileApi } from "../../../../services/profile.service";
import SideNav from "../sideNavs/protectedSideNav";
import SideNavErrorUi from "../../../../components/errorBoundary/sideNavErrorUi";
import AppLogo from "../../../../components/common/appLogo";
import handleNavigation from "../../../../utils/paymentNavigation";
import { homeBaseUrl } from "../../../../constants/url";

import {
  storeUserData,
  userEmail,
  userName,
  userFirstName,
  userPhone,
  userProfile_pic,
  activeSurveyId,
} from "../../../../store/slice/profile.slice";

interface PageHeaderInterface {
  hideSideNav?: boolean;
}

const PageHeaderComponent: React.FC<PageHeaderInterface> = (props) => {
  const dispatch = useAppDispatch();
  const { hideSideNav } = props;
  const navigate = useNavigate();
  const state = useAppSelector((state) => state);
  const { name, profile_pic } = state?.profile;
  let token = localStorage.getItem("alrounderToken");

  useEffect(() => {
    if (token && token !== "undefined") {
      fetchUserDetails();
    }
  }, [token]);

  const fetchUserDetails = () => {
    dispatch(
      getProfileApi({
        finalCallback: () => {},
        successCallback: (response?: any) => {
          // if (!response?.has_store) {
          //   navigate(handleNavigation(response?.survey_status, response?.has_store))
          // }
          dispatch(userName({ name: response?.name }));
          dispatch(userFirstName({ name: response?.name }));
          dispatch(userPhone({ phone: response?.phone }));
          dispatch(userEmail({ email: response?.email }));
          dispatch(userProfile_pic({ profile_pic: response?.profile_pic }));
          dispatch(activeSurveyId(response?.active_survey_id));
        },
        unauthenticatedCallback: () => {},
      })
    );
  };

  const items: MenuProps["items"] = hideSideNav
    ? [
        {
          key: "1",
          label: (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              onClick={() => {
                localStorage.clear();
                window.location.replace(homeBaseUrl);
                // navigate("/");
              }}
            >
              Log Out
            </a>
          ),
        },
      ]
    : [
        {
          key: "1",
          label: (
            <Link rel="noopener noreferrer" to="/edit-profile">
              Edit Profile
            </Link>
          ),
        },
          {
          key: "2",
          label: (
            <Link to="/billing-subscription">
             Subscription and Billing 
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              onClick={() => {
                dispatch(storeUserData({}));
                localStorage.clear();
                // window.location.replace(homeBaseUrl);
                navigate("/login");
              }}
            >
              Log Out
            </a>
          ),
        },
      ];

  return (
    <div className="page-header">
      {hideSideNav ? (
        <></>
      ) : (
        <div className="page-header-leftSide">
          <ErrorBoundary FallbackComponent={SideNavErrorUi} onReset={() => {}}>
            <SideNav />
          </ErrorBoundary>
        </div>
      )}
      <div className="page-header-centerSide">
        <a
          href="https://missingskincare.com/"
          className="brand-logo"
          target="_blank"
          rel="noreferrer"
        >
          <AppLogo />
        </a>
      </div>
      <div className="page-header-rightSide">
        <Dropdown
          menu={{ items }}
          onOpenChange={(val) => {
            if (val) {
              ReactGA.event({
                category: "Header",
                action: `Profile dropdown opened`,
                label: "Profile dropdown on header hovered",
                nonInteraction: true, // optional, true/false
                transport: "xhr",
              });
            }
          }}
        >
          <Button
            href="#"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Avatar shape="circle" size={44} src={profile_pic ?? placeHolder} />
            <Space>
              {state?.profile?.name ? (
                <span className="username">{state?.profile?.name}</span>
              ) : (
                <></>
              )}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

export default PageHeaderComponent;
